import '@repo/common/font-css'
import './index.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import { LDPlugin } from 'launchdarkly-vue-client-sdk'
import { createPinia } from 'pinia'
import { segmentPlugin } from './plugins/segment'
import flagSmithPlugin from './plugins/flagsmith'
import { createHead } from '@unhead/vue/client'

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import timezonePlugin from 'dayjs/plugin/timezone'
import sentryPlugin from './plugins/sentry'
import { VueQueryPlugin } from '@tanstack/vue-query'

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezonePlugin)

const pinia = createPinia()
const head = createHead()

const app = createApp(App)
  .use(flagSmithPlugin)
  .use(VueQueryPlugin)
  .use(router)
  .use(LDPlugin, { clientSideID: import.meta.env.VITE_LD_CLIENT_SIDE_ID, deferInitialization: true })
  .use(segmentPlugin, { writeKey: import.meta.env.VITE_SEGMENT_WRITE_KEY })
  .use(sentryPlugin)
  .use(pinia)
  .use(head)

router.isReady().then(() => {
  app.mount('#app')
})
